<template>
  <container>
    <div class="page-not-found-page w-100 p-0 m-0">
      <h1>Page Not Found</h1>
    </div>
  </container>
</template>
<script>
/**
 * ==================================================================================
 * Page Not Found page
 * ==================================================================================
 **/

import MainLayout from '@/layouts/MainLayout'

export default {
  metaInfo: function() {
    return {
      title: 'Page not found'
    }
  },
  components: {
    container: MainLayout
  }
}
</script>
<style lang="scss" scoped>
.main-layout {
  height: 100%;
}

.page-not-found-page {
  display: flex;
  height: 80%;
  justify-content: center;
  align-items: center;

  h1 {
    text-align: center;
  }
}
</style>
